import { isPlatformBrowser } from '@angular/common';
import { Component, PLATFORM_ID, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UserDataService } from '../../shared/services/auth/userData.service';

@Component({
  selector: 'app-building-shell',
  standalone: true,
  template: ''
})
export class BuildingShellComponent {
  constructor() {
    const route         = inject(ActivatedRoute);
    const router        = inject(Router);
    const userDataService = inject(UserDataService);
    const platformId    = inject(PLATFORM_ID);

    route.paramMap.subscribe((params) => {
      const buildingId = params.get('buildingId');
      const siteAdmin  = params.get('siteAdmin');
      const isOrg      = params.get('isOrg');

      if (isOrg === null) {
        userDataService.isOrg.set(false);
        if (isPlatformBrowser(platformId)) localStorage.setItem('lockdown_is_org', 'false');
        router.navigate(['/missing-building']);
        return;
      }

      if (buildingId) {
        userDataService.buildingId.set(buildingId);
        if (isPlatformBrowser(platformId)) {
          localStorage.setItem('lockdown_building_id', buildingId);
          localStorage.setItem('lockdown_site_admin',  siteAdmin ?? 'false');
          localStorage.setItem('lockdown_is_org',      isOrg);
        }
      }
      const isAdmin = siteAdmin === 'true';
      if (siteAdmin !== null) userDataService.siteAdmin.set(isAdmin);
      userDataService.isOrg.set(isOrg === 'true');
      router.navigate([isAdmin ? '/user' : '/no-access']);
    });
  }
}
